import { useTheme } from '@mui/material';
import { isDesktop } from 'react-device-detect';

import { colors } from '../../../../constants/colors';

import { ScreenSizes } from '../../../../interfaces';
import { IStyles } from '../../../../interfaces/styles';

export const useStyles = (): IStyles => {
  const { breakpoints } = useTheme();

  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      rowGap: isDesktop ? '53px' : '45px',
      width: '100%',
    },
    container: {
      position: 'relative',
    },
    layoutContainer: {
      [breakpoints.down(ScreenSizes.Pc)]: {
        position: 'relative',
      },
      '& form': {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        rowGap: 3,
        mb: 3,
      },
    },
    title: {
      fontWeight: 400,
      fontSize: 32,
      lineHeight: 1.25,
      color: colors.oxford_60,
      mb: '36px',
      textAlign: 'center',
    },
    nameContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      columnGap: 3,
    },
    divider: {
      mb: 2,
      '& .MuiDivider-wrapper': {
        fontWeight: 500,
        fontSize: 14,
        lineHeight: 1.43,
        letterSpacing: '0.1px',
        color: colors.oxford,
        opacity: 0.4,
      },
      '&::before': {
        borderTop: `1px solid ${colors.oxford_20}`,
      },
      '&::after': {
        borderTop: `1px solid ${colors.oxford_20}`,
      },
    },
    socialButtonsContainer: {
      display: 'flex',
      columnGap: '17px',
    },
  };
};
